<div class="project-card" [class.mt-4]="!isdeleted()">
  <div class="project-card-header">
    <p class="project-card-header-title">
      {{ projectData().project | truncateWord : 3 }}
      @if(titleArr.length > 3){
      <span class="read-more" (click)="displayDrilldown()">read more</span>
      }
    </p>
    @if(isAdmin() && projectData().id)
    {
      <button class="show-menu-btn" (click)="showActionsPopup()">
        <i class="pi pi-clock"></i>
      </button>
    }
    <!-- <button class = "show-menu-btn" [matMenuTriggerFor]="menu">
      <i class="pi pi-ellipsis-v"></i>
    </button>
    <mat-menu #menu="matMenu" class = "edit-delete-project">
      <button mat-menu-item (click)="editProject()">
        <img src="assets/images/edit-project.svg" alt="">
        <span class = "edit-btn">edit</span>
      </button>
      <button mat-menu-item (click)="deleteProject()">
        <img src="assets/images/delete-project.svg" alt="">
        <span class = "delete-btn">delete</span>
      </button>
    </mat-menu> -->
  </div>
  <div>
    <div class="project-card-bar" style="padding: 0 10px">
      <stc-apps-progress-bar
        [data]="data"
        [isProject]="true"
        [fontFamily]="'STCForwardFont'"
      />
    </div>
  </div>
</div>
@if(titleArr.length > 3) {
<p-overlayPanel #overlayPanel dismissable="true">
  <section class="popover-section">{{ projectData().project }}</section>
</p-overlayPanel>
}
@if(isAdmin() && projectData().id)
{
  <p-overlayPanel
        #actionsPanel
        dismissable="false"
        appendTo="body"
        styleClass="actions-logs12"
      >
        <div class="actions-logs-table">
          <div class="action" (click)="showActivityLogs()">
            <i class="pi pi-clock"></i>
            <p>activity log</p>
          </div>
        </div>
      </p-overlayPanel>
      @if(showActivityLogsPopup)
      {
        <stc-apps-activity-logs-popup
          [activityLogsTableHeader]="activityLogsTableHeader()"
          [activityLogsTableBody]="activityLogsTableBody()"
          [showPopup]="showActivityLogsPopup"
          (popupClosed)="popupClosed()"
          [isProjectActionPopup]="true"
          type = "cad"
          [isDismissable]="true"
          [isPSRProject]="true"
        />
      }
}